<div class="ks-card" *ngIf="!submitting">
  <header class="ks-card-header">
    <div class="ks-card-header__title">
      <h2 class="ks-h2 ks-mb-0">Payment Processing</h2>
    </div>
    <div class="ks-card-header__tools">
      <div>
        <button
          type="button"
          ktTooltip="Close"
          class="ks-btn-xs ks-btn-icon-round ks-btn-flat-neutral"
          (click)="cancel()"
        >
          <span inlineSVG="assets/icons/Close.svg"></span>
        </button>
      </div>
    </div>
  </header>
  <div
    style="display: flex"
    class="ks-mt-5 ks-mb-5"
    *ngIf="activeTabIdx > 0"
    (click)="activeTabIdx = activeTabIdx - 1"
  >
    <button
      type="button"
      ktTooltip="Back"
      class="ks-btn ks-btn-xxxs ks-btn-icon ks-btn-outline-neutral ks-mr-3 ks-ml-6"
    >
      <span inlineSVG="assets/icons/Chevron-left.svg"></span>
    </button>
    <h6>Previous</h6>
  </div>
  <main class="ks-p-0" style="height: inherit">
    <div class="ks-stepper">
      <nav class="ks-stepper-tabs ks-mb-6">
        <ng-container *ngFor="let tab of tabs; let idx = index">
          <div class="display-block-step" *ngIf="idx === activeTabIdx">
            <div class="ks-neutral-darker">Step {{ idx + 1 }}.</div>
            <p class="text-muted">{{ tab }}</p>
          </div>
        </ng-container>
      </nav>
      <div style="display: flex" class="ks-ml-5 ks-mr-5">
        <ng-container *ngFor="let tabLine of tabs; let idx = index">
          <div
            class="stepper-underline-div"
            [class.stepper-underline-div-active]="idx <= activeTabIdx"
          ></div>
        </ng-container>
      </div>
      <div class="ks-scrollbar-tertiary ks-mt-10">
        <div #top></div>
        <ng-container [ngSwitch]="activeTabIdx">
          <kt-payment-details-tab
            #paymentDetails
            *ngSwitchCase="tabs.indexOf('Details')"
            [triggerSave]="triggerSave"
            (customerId)="customerId = $event"
          ></kt-payment-details-tab>
          <kt-payment-method-tab
            #paymentMethod
            [organization]="data.organization"
            *ngSwitchCase="tabs.indexOf('Method')"
            [customerId]="this.payment?.contact?.contactUUID"
          ></kt-payment-method-tab>
          <kt-payment-preview-tab *ngSwitchCase="tabs.indexOf('Review')"></kt-payment-preview-tab>
        </ng-container>
      </div>
    </div>
  </main>
  <footer class="ks-card-footer">
    <div class="ks-d-flex ks-w-100">
      <button
        type="button"
        class="ks-btn-md ks-btn-outline-neutral ks-mr-5 ks-w-100 ks-text-center"
        (click)="cancel()"
      >
        Exit payment
      </button>
      <button
        type="button"
        class="ks-btn-md ks-btn-primary ks-w-100 ks-text-center"
        (click)="save()"
        [disabled]="processing"
      >
        <span> {{ activeTabIdx !== tabs.indexOf('Review') ? 'Continue' : 'Submit' }} </span>
      </button>
    </div>
  </footer>
</div>
<div class="payment-notification" *ngIf="submitting">
  <div class="payment-success-card">
    <div
      class="warning-badge-payment"
      style="padding-top: 25px; justify-self: center"
      *ngIf="!submitData.success"
    >
      <span inlineSVG="assets/icons/Close.svg" class="ks-text-danger ks-m-4"></span>
    </div>
    <div
      class="success-badge-payment"
      style="padding-top: 25px; justify-self: center"
      *ngIf="submitData.success"
    >
      <span inlineSVG="assets/icons/Check.svg" class="ks-text-success ks-m-4"></span>
    </div>

    <h1 *ngIf="submitData.success" class="ks-mt-5 ks-text-center">Payment Successfully</h1>
    <h1 *ngIf="!submitData.success" class="ks-mt-5 ks-text-center">Payment Failed</h1>

    <p class="thank-you" *ngIf="submitData.success">Successfully paid amount for jo Aqra.</p>

    <div class="contact-info" *ngIf="!submitData.success">
      <p>{{ submitData.description }}</p>
    </div>

    <div class="contact-info" *ngIf="!submitData.success">
      <p>
        The action could not be completed. Please contact the administrator for assistance, press
        close to exit, or try again to attempt the operation once more. We apologize for any
        inconvenience.
      </p>
    </div>

    <div class="actions ks-d-flex">
      <button
        *ngIf="submitData.success"
        type="button"
        class="ks-d-inline ks-btn-md ks-btn-success ks-mr-5 ks-w-100"
        (click)="cancel()"
      >
        Ok
      </button>
      <button
        *ngIf="!submitData.success"
        type="button"
        class="ks-d-inline ks-btn-md ks-btn-outline-neutral ks-mr-5 ks-w-50"
        (click)="cancel()"
      >
        Cancel Payment
      </button>
      <button
        *ngIf="!submitData.success"
        type="button"
        class="ks-d-inline ks-btn-md ks-btn-primary ks-w-50"
        (click)="cancel(); reTry()"
      >
        Try Again
      </button>
    </div>
  </div>
</div>
